<script>
  import { createEventDispatcher } from "svelte"

  let dispatch = createEventDispatcher()
  let hideStickers = false

  function onToggle() {
    hideStickers = !hideStickers
    dispatch("toggleStickers", {
        hideStickers: hideStickers  
    })
  }
</script>

<style>
/* The switch - the box around the slider */
.switch {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  width: 90px;
  height: 24px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: black;
  border: solid white 2px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 4px;
  bottom: 3px;
  background-color: #FFF575;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: black;
  border: solid white 2px;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(65px);
  -ms-transform: translateX(65px);
  transform: translateX(65px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>


<label class="switch">
  <input type="checkbox" on:input={onToggle}>
  <span class="slider round"></span>
</label>